import ReactGA from "react-ga4";

export default ReactGA;
